const ACTION_PATH_PATTERN = /^\/frequentDestination\/(?:[^/]+\/(?:modify(?:\/confirmation)?|delete)|create\/[^/]+\/confirm)\/?$/i;
export const DEFAULT_FREQUENT_DESTINATION_GO_BACK_PATH = "/FrequentDestination";

/**
 * Resolves the shell back target from the previous screen (`status.lastHref`).
 * Falls back to the frequent destinations list when the origin is missing or is one of the
 * flow action routes (create confirm, modify, modify confirmation, delete).
 * @param {string} lastHrefPathname - Pathname from the previous navigation entry.
 * @returns {string} Path to use as `goBackPath` in the V3 shell layout.
 */
export function resolveFrequentDestinationGoBackPath(lastHrefPathname) {
    if (
        typeof lastHrefPathname === "string" &&
        lastHrefPathname.startsWith("/") &&
        lastHrefPathname !== "/" &&
        !ACTION_PATH_PATTERN.test(lastHrefPathname)
    ) {
        return lastHrefPathname;
    }
    return DEFAULT_FREQUENT_DESTINATION_GO_BACK_PATH;
}
